import { useEffect, useMemo, useState } from "react";

export default function useHeroBackground() {
  const [heroes, setHeroes] = useState([]);
  useEffect(() => {
    fetch("/landingPageHero.json").then(r => r.json()).then(setHeroes).catch(() => {});
  }, []);

  const hero = useMemo(
    () => (heroes.length ? heroes[Math.random() * heroes.length | 0] : null),
    [heroes]
  );

  const bg = useMemo(() => {
    if (!hero) return "";
    const order = ["avif", "webp", "jpeg", "jpg", "png"];
    const build = (ext, dpr) =>
      hero.src?.[ext]?.[dpr]
        ? `url("${hero.src[ext][dpr]}") type("image/${ext === "jpg" ? "jpeg" : ext}") ${dpr}`
        : null;
    const parts = order.flatMap(ext => [build(ext, "1x"), build(ext, "2x")]).filter(Boolean);
    return `image-set(${parts.join(",")})`;
  }, [hero]);

  const alt = hero?.description ?? "Background image";
  return { bg, alt };
}
